// AUTO-GENERIERT (scripts/generate-version.mjs) — nicht manuell bearbeiten.
export const APP_VERSION = '0.1.0';
